export function feature_js_slider(el) {
    var sliderId = el.attr('js-slider');
    $(el).click(function () {
        $('body').find('[slider-' + sliderId + ']').slideToggle();
    });
}